interface HalalBadgeProps {
  size?: number;
  className?: string;
}

/** Circular Halal mark supplied by the restaurant (transparent PNG). */
const HalalBadge = ({ size = 44, className = '' }: HalalBadgeProps) => (
  <span
    className={`inline-flex items-center justify-center flex-shrink-0 ${className}`}
    style={{ width: size, height: size }}
    title="Halal"
    aria-label="Halal"
  >
    <img
      src="/branding/halal-logo.png"
      alt=""
      aria-hidden="true"
      className="w-full h-full object-contain"
      style={{
        filter:
          'drop-shadow(0 1px 2px rgba(0,0,0,0.35)) drop-shadow(0 0 1px rgba(255,255,255,0.9))',
      }}
    />
  </span>
);

export default HalalBadge;
